import { HttpParams } from '@angular/common/http';

export class OnboardingUserFilter {

	name_user: string | undefined;
	lastName_user: string | undefined;
	email_user: string | undefined;
	status_user: number | undefined;

	constructor(filter?: OnboardingUserFilter) {
		if (filter) {
			this.name_user = filter.name_user;
			this.lastName_user = filter.lastName_user;
			this.email_user = filter.email_user;
			this.status_user = filter.status_user;
		}
	}

	getHttpParams(httpParams = new HttpParams()): HttpParams {
		if (this.name_user) {
			httpParams = httpParams.set('name', this.name_user);
		}
		if (this.lastName_user) {
			httpParams = httpParams.set('lastName', this.lastName_user);
		}
		if (this.email_user) {
			httpParams = httpParams.set('email', this.email_user);
		}
		if (this.status_user) {
			httpParams = httpParams.set('status', this.status_user.toString());
		}
		return httpParams;
	}
}
